import { showErrorDialog } from 'v3/data/store/error/actions';
import { setProductLmi } from 'v3/data/store/product/actions';
import { updateLmi } from 'v3/services/api';
import { ISku } from 'v3/services/interfaces/response';

export const changeProductLmi = async (sku: ISku): Promise<void> => {
  const { storage, lmi, id, product } = sku;
  try {
    await updateLmi({ productId: product.id, lmi, storage });
    setProductLmi({
      id,
      lmi,
      storage,
    });
  } catch (error) {
    showErrorDialog('Erro ao atualizar o LMI do produto', error);
  }
};
